import { render } from "./multiple.vue?vue&type=template&id=f5a0e85a&scoped=true"
import script from "./multiple.vue?vue&type=script&lang=js"
export * from "./multiple.vue?vue&type=script&lang=js"

import "./multiple.vue?vue&type=style&index=0&id=f5a0e85a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5a0e85a"]])

export default __exports__